import { Capacitor } from "@capacitor/core";

export function isNativeRuntime(): boolean {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent?.toLowerCase?.() ?? "";
  return ua.includes("despia") || Capacitor.isNativePlatform();
}
